export * from './device-attributes-values.component';
